import { render, staticRenderFns } from "./loading-triangle.vue?vue&type=template&id=70d712fc&scoped=true&"
import script from "./loading-triangle.vue?vue&type=script&lang=js&"
export * from "./loading-triangle.vue?vue&type=script&lang=js&"
import style0 from "./loading-triangle.vue?vue&type=style&index=0&id=70d712fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d712fc",
  null
  
)

export default component.exports